import { render, staticRenderFns } from "./FileBlock.vue?vue&type=template&id=73636a02&scoped=true"
import script from "./FileBlock.vue?vue&type=script&lang=js"
export * from "./FileBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73636a02",
  null
  
)

export default component.exports